import styled, { css } from "styled-components";
import { Wrapper } from "AppReact";

const template = styled.div`
  ${({ theme }) => css`
    padding: 20px 24px;
    width: 460px;
    height: 107px;
    border: 1px solid #E3E3E3;
    border-radius: 12px;
    display: flex;

    &:hover {
      background: ${`${theme?.colour?.primary}0D`};
    }

    > div:last-child {
      display: none;
    }

    &:hover > div:first-child {
      display: none; 
    }

    &:hover > div:last-child {
      display: flex; 
    }
  `}
`;

export default Wrapper(template);